import * as apiValues from '../constants/apiValues';
import * as helpers from '../helpers';
import * as mHeaderActions from '../actions/mHeaderActions';
import iconShareYourFeedback from '../img/icons/icon-share-your-feedback.svg';
import MHeaderTab from './MHeaderTab';
import MListNav from './MListNav';
import PropTypes from 'prop-types';
import React from 'react';
import GoogleTranslate from './GoogleTranslate';
import SuperLink from './SuperLink';
import {bindActionCreators} from 'redux';
import ButtonInput from './ButtonInput';
import {connect} from 'react-redux';
import {withRouter} from '../withRouterCompat';


const MOBILE_NAV_MAX_WIDTH = 991; // Bootstrap lg breakpoint (992px) minus 1

class MHeader extends React.Component{
  constructor(){
    super();
    this.state = {
      height: window.innerHeight,
      width: window.innerWidth,
      suggestedProjects: {
        title: 'Suggested Projects',
        navigationLinks: [],
      },
      suggestedPages: {
        title: 'Suggested Pages',
        navigationLinks: [],
      },
      keyword: null,
      suggestionsPending: false,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
  }
  UNSAFE_componentWillMount(){
    this.handleSearchInputChange = helpers.debounceEvent((query) => {
      this.handleSearch(query);
    }, 300);
  }
  componentDidMount(){
    //console.log(`MHeader.componentDidMount()`, this.props);
    this.props.actions.initMHeader();
    this.props.actions.expandedTab({
      expandedTabBarVisible: false,
      expandedTabBarOffset: 0,
      expandedTabBarWidth: 0,
    });
    window.addEventListener('resize', this.updateDimensions);
    document.addEventListener('keydown', this.onNavKeydown);
    if(this.isMobileHamburgerTrap()){
      document.addEventListener('focusin', this.onMobileHamburgerFocusIn, true);
    }
    this.updateDimensions();
    this.props.actions.toggleSearch(false);
    this.setState({
      suggestedProjects: {
        title: 'Suggested Projects',
        navigationLinks: [],
      },
      suggestedPages: {
        title: 'Suggested Pages',
        navigationLinks: [],
      },
      keyword: null,
      suggestionsPending: false,
    });
  }
  componentDidUpdate(prevProps){
    const wasTrap = this.isMobileSearchTrap(prevProps.mHeaderTab);
    const isTrap = this.isMobileSearchTrap();
    if(isTrap && !wasTrap){
      document.addEventListener('keydown', this.onMobileSearchTrapKeydown);
      document.addEventListener('focusin', this.onMobileSearchFocusIn, true);
    }
    else if(!isTrap && wasTrap){
      document.removeEventListener('keydown', this.onMobileSearchTrapKeydown);
      document.removeEventListener('focusin', this.onMobileSearchFocusIn, true);
    }

    const wasHamburgerTrap = this.isMobileHamburgerTrap(prevProps.mHeader, prevProps.mHeaderTab);
    const isHamburgerTrap = this.isMobileHamburgerTrap();
    if(isHamburgerTrap && !wasHamburgerTrap){
      document.addEventListener('focusin', this.onMobileHamburgerFocusIn, true);
    }
    else if(!isHamburgerTrap && wasHamburgerTrap){
      document.removeEventListener('focusin', this.onMobileHamburgerFocusIn, true);
    }
  }
  componentWillUnmount(){
    if(this.handleSearchInputChange && this.handleSearchInputChange.cancel){
      this.handleSearchInputChange.cancel();
    }
    window.clearTimeout(this._tabBarHideTimer);
    window.removeEventListener('resize', this.updateDimensions);
    document.removeEventListener('keydown', this.onNavKeydown);
    document.removeEventListener('keydown', this.onMobileSearchTrapKeydown);
    document.removeEventListener('focusin', this.onMobileSearchFocusIn, true);
    document.removeEventListener('focusin', this.onMobileHamburgerFocusIn, true);
  }

  isMobileSearchTrap(headerTabState){
    const tabs = headerTabState || this.props.mHeaderTab;
    const searchTab = helpers.getById(tabs, 'search');
    return this.isMobileNavViewport() && Boolean(searchTab && searchTab.isOpen);
  }
  isMobileHamburgerTrap(mHeaderState, headerTabState){
    const header = mHeaderState || this.props.mHeader;
    const tabs = headerTabState || this.props.mHeaderTab;
    if(!this.isMobileNavViewport()){
      return false;
    }
    if(!header?.isOpen){
      return false;
    }
    const searchTab = helpers.getById(tabs, 'search');
    return !(searchTab && searchTab.isOpen);
  }
  isMobileSubmenuOpen(headerTabState){
    const tabs = headerTabState || this.props.mHeaderTab;
    if(!Array.isArray(tabs)){
      return false;
    }
    return tabs.some(tab => tab.isOpen);
  }
  onMobileSearchTrapKeydown = event => {
    if(event.key === 'Escape'){
      event.preventDefault();
      this.closeSearch();
    }
  };
  onNavKeydown = event => {
    if(event.key !== 'Escape'){
      return;
    }
    if(this.isMobileSearchTrap()){
      return;
    }
    if(this.isMobileNavViewport() && this.isMobileHamburgerTrap()){
      const openTab = (this.props.mHeaderTab || []).find(tab => tab.isOpen);
      if(openTab){
        event.preventDefault();
        this.props.actions.tabToggle(openTab.id, false);
        window.setTimeout(() => {
          document.getElementById(`trigger-${openTab.id}-mobile`)?.focus();
        }, 0);
        return;
      }
      event.preventDefault();
      this.toggleMenu(false);
      window.setTimeout(() => {
        document.querySelector('.m-header__menu-toggle')?.focus();
      }, 0);
      return;
    }
    if(this.isMobileNavViewport()){
      return;
    }
    const expandedTab = this.props.mHeader?.expandedTab;
    if(!expandedTab || expandedTab === 'search'){
      return;
    }
    event.preventDefault();
    this.tab_onMouseLeave();
    window.setTimeout(() => {
      document.getElementById(`trigger-${expandedTab}`)?.focus();
    }, 0);
  };
  onTabTriggerToggle = (tabId, event) => {
    if(this.isMobileNavViewport()){
      return;
    }
    if(this.tabNavExpanded(tabId)){
      this.tab_onMouseLeave();
      return;
    }
    const tabEl = event?.currentTarget?.closest?.('.m-header__tab') ||
      document.getElementById(`trigger-${tabId}`)?.closest('.m-header__tab');
    if(tabEl){
      this.tab_onMouseEnter(tabId, {currentTarget: tabEl});
    }
  };
  onTabTriggerDismiss = (tabId) => {
    if(this.isMobileNavViewport()){
      const tabState = helpers.getById(this.props.mHeaderTab, tabId);
      if(tabState?.isOpen){
        this.props.actions.tabToggle(tabId, false);
        window.setTimeout(() => {
          document.getElementById(`trigger-${tabId}-mobile`)?.focus();
        }, 0);
      }
      return;
    }
    this.tab_onMouseLeave();
    window.setTimeout(() => {
      document.getElementById(`trigger-${tabId}`)?.focus();
    }, 0);
  };
  onMobileSearchFocusIn = event => {
    if(!this.isMobileSearchTrap()){
      return;
    }
    const menu = document.querySelector('.m-header__tab--search.is-open .m-header__tab-menu');
    if(!menu || menu.contains(event.target)){
      return;
    }
    if(event.target.closest('[id^="global_navbar"]')){
      return;
    }
    this.closeSearch();
  };
  getMobileHamburgerFocusables(){
    const header = document.querySelector('.m-header');
    if(!header){
      return [];
    }
    return Array.from(header.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    )).filter(el => {
      if(el.closest('[inert]')){
        return false;
      }
      const style = window.getComputedStyle(el);
      return style.visibility !== 'hidden' && style.display !== 'none';
    });
  }
  onMobileHamburgerFocusIn = event => {
    if(!this.isMobileHamburgerTrap()){
      return;
    }
    const header = document.querySelector('.m-header');
    if(!header || header.contains(event.target)){
      return;
    }
    if(event.target.closest('[id^="global_navbar"]')){
      return;
    }
    const focusables = this.getMobileHamburgerFocusables();
    focusables[0]?.focus();
  };

  closeSearch = ({restoreFocus = true} = {}) => {
    const returnFocus = this.props.mHeader?.searchReturnFocus || 'header';
    this.props.actions.menuToggle(false);
    this.props.actions.tabToggle('search', false);
    this.props.actions.toggleSearch(false);
    this.props.actions.setSearchReturnFocus(null);
    // Always collapse the overlay. tab_onMouseLeave no-ops while the pointer is
    // still over the panel, which is the usual case when pressing Enter.
    this.forceHideExpandedTab();
    this._searchKeyword = null;
    this.setState({keyword: null, suggestionsPending: false});
    // Blur first so desktop :focus-within styles don't keep the search overlay painted.
    if(typeof document !== 'undefined' && document.activeElement?.blur){
      document.activeElement.blur();
    }
    if(!restoreFocus){
      return;
    }
    window.setTimeout(() => {
      if(returnFocus === 'hero'){
        this.focusAfterHeroSearchClose();
      }
      else{
        document.getElementById('trigger-search')?.focus();
      }
    }, 0);
  };
  forceHideExpandedTab = () => {
    window.clearTimeout(this._tabBarHideTimer);
    this.props.actions.expandedTab({
      expandedTabBarVisible: false,
      expandedTabBarWidth: 0,
      expandedTab: '',
    });
    if(!this.isMobileNavViewport()){
      this.props.actions.toggleAllTabs(false);
      this.props.actions.toggleSearch(false);
    }
  };
  focusAfterHeroSearchClose(){
    const heroInput = document.querySelector('.site-search--carousel-slide .button-input__input');
    if(heroInput){
      heroInput.blur();
    }
    window.setTimeout(() => {
      const dotButton = document.querySelector('.m-carousel .control-dots .dot.selected .m-carousel__dot-button') ||
        document.querySelector('.m-carousel .control-dots .m-carousel__dot-button');
      dotButton?.focus();
    }, 0);
  };
  onSearchClearClick = () => {
    // ButtonInput also calls this after Enter when onSubmit returns true. The panel is
    // already closed by search_onSubmit — don't restore focus to the search trigger or
    // :focus-within / onTabFocusIn will reopen the overlay over /search results.
    const searchTab = helpers.getById(this.props.mHeaderTab, 'search');
    const alreadyClosed = !(searchTab && searchTab.isOpen);
    this.closeSearch({restoreFocus: !alreadyClosed});
  };
  onSearchInputChange = event => {
    const value = event.target.value;
    const keyword = value === '' ? null : value;
    this._searchKeyword = keyword;

    const isSearchOpen = Boolean(keyword);
    if(Boolean(this.props.mHeader?.isSearchOpen) !== isSearchOpen){
      this.props.actions.toggleSearch(isSearchOpen);
    }

    if(!keyword){
      if(this.handleSearchInputChange && this.handleSearchInputChange.cancel){
        this.handleSearchInputChange.cancel();
      }
      this.setState({
        keyword: null,
        suggestionsPending: false,
        suggestedProjects: {
          title: 'Suggested Projects',
          navigationLinks: [],
        },
        suggestedPages: {
          title: 'Suggested Pages',
          navigationLinks: [],
        },
      });
      return;
    }

    if(!this.state.keyword || !this.state.suggestionsPending){
      this.setState({
        keyword,
        suggestionsPending: true,
      });
    }
    this.handleSearchInputChange(value);
  };
  onSearchTabClick = () => {
    this.props.actions.menuToggle(false);

    if(this.isMobileNavViewport()){
      const searchTab = helpers.getById(this.props.mHeaderTab, 'search');
      const willOpen = !(searchTab && searchTab.isOpen);

      if(willOpen){
        this.props.actions.setSearchReturnFocus('header');
        this.props.actions.tabToggle('search', true);
        this.props.actions.expandedTab({
          expandedTabBarVisible: false,
          expandedTab: 'search',
        });
        setTimeout(() => {
          document.getElementById('search-main')?.focus();
        }, 0);
      }
      else{
        this.closeSearch();
      }
      return;
    }

    this.props.actions.setSearchReturnFocus('header');
    this.props.actions.tabToggle('search', true);
    this.props.actions.expandedTab({
      expandedTabBarVisible: false,
      expandedTab: 'search',
    });
    setTimeout(() => {
      document.getElementById('search-main')?.focus();
    }, 0);
  };
  search_onSubmit = () => {
    const keyword = (this._searchKeyword || this.state.keyword || '').trim();
    if(!keyword) return;
    // Don't bounce focus back to the search trigger — that reopens the panel via
    // :focus-within and hides the /search results underneath (LLSU2-167).
    // Do not return true: ButtonInput would then clear + restore trigger focus
    // in the same tick and the overlay would paint again over /search.
    this.closeSearch({restoreFocus: false});
    this.props.history.push(`/search?q=${encodeURIComponent(keyword)}`);
    window.setTimeout(() => {
      const main = document.getElementById('main');
      if(main){
        if(!main.hasAttribute('tabindex')){
          main.setAttribute('tabindex', '-1');
        }
        main.focus({preventScroll: true});
      }
    }, 0);
  };
  onViewAllSearchResults = evt => {
    if(evt && evt.preventDefault){
      evt.preventDefault();
    }
    const keyword = (this._searchKeyword || this.state.keyword || '').trim();
    this.closeSearch({restoreFocus: false});
    this.props.history.push(keyword ? `/search?q=${encodeURIComponent(keyword)}` : '/search');
  };
  tabNavExpanded(tabId){
    const tabState = helpers.getById(this.props.mHeaderTab, tabId);
    if(this.isMobileNavViewport()){
      return Boolean(tabState && tabState.isOpen);
    }
    return this.props.mHeader.expandedTab === tabId;
  }
  tab_onMouseEnter = (tabName, e) => {
    if(this.isMobileNavViewport()){
      return;
    }
    if(!tabName){
      return;
    }
    let target = e?.currentTarget;
    // Search icon is the tab-link; the tab wrapper can be wider/offset differently.
    if(tabName === 'search' && target){
      target = target.querySelector('.m-header__tab-link') || target;
    }
    this.showExpandedTabBar(tabName, target);
  };
  isHeaderTabBarHovered = () => {
    if(typeof document === 'undefined'){
      return false;
    }
    return Boolean(document.querySelector(
      '.m-header__tabs-middle .m-header__tab:hover, .m-header__tab--search:hover, .m-header__language:hover',
    ));
  };
  showExpandedTabBar = (tabName, el) => {
    if(this.isMobileNavViewport() || !el){
      return;
    }
    const tabs = document.querySelector('.m-header__tabs');
    if(!tabs){
      return;
    }
    window.clearTimeout(this._tabBarHideTimer);
    const tabsRect = tabs.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    this.props.actions.expandedTab({
      expandedTabBarVisible: true,
      expandedTabBarOffset: elRect.left - tabsRect.left,
      expandedTabBarWidth: elRect.width,
      expandedTab: tabName,
    });
  };
  hideExpandedTabBarSoon = () => {
    window.clearTimeout(this._tabBarHideTimer);
    this._tabBarHideTimer = window.setTimeout(() => {
      if(this.isHeaderTabBarHovered()){
        return;
      }
      this.props.actions.expandedTab({
        expandedTabBarVisible: false,
        expandedTabBarWidth: 0,
        expandedTab: '',
      });
    }, 300);
  };
  headerUtility_onMouseLeave = (e) => {
    if(this.isMobileNavViewport()){
      return;
    }
    const related = e?.relatedTarget;
    if(related && typeof related.closest === 'function'){
      if(
        related.closest('.m-header__tabs-middle .m-header__tab') ||
        related.closest('.m-header__tab--search') ||
        related.closest('.m-header__language')
      ){
        return;
      }
    }
    // Delay + hover recheck so brief relatedTarget=null blips while scrubbing
    // the translate control do not fade the underline away.
    this.hideExpandedTabBarSoon();
  };
  tab_onMouseLeave = () => {
    if(this.isHeaderTabBarHovered()){
      return;
    }
    window.clearTimeout(this._tabBarHideTimer);
    this.props.actions.expandedTab({
      expandedTabBarVisible: false,
      expandedTabBarWidth: 0,
      expandedTab: '',
    });
    if(!this.isMobileNavViewport()){
      this.props.actions.toggleAllTabs(false);
      this.props.actions.toggleSearch(false);
    }
  };


  bgPath(){
    const mHeader = this.props.mHeader;
    if (!mHeader) return '';
    const bg = mHeader.imageBackground || mHeader.ImageBackground;
    return (bg && (bg.url || bg.Url)) || '';
  }
  toggleMenu = (isOpen) => {
    const nextOpen = typeof isOpen !== 'undefined' ? isOpen : !this.props.mHeader.isOpen;
    this.props.actions.menuToggle(nextOpen);
    this.props.actions.toggleAllTabs(false);
    if(nextOpen && this.isMobileNavViewport()){
      window.setTimeout(() => {
        document.querySelector('.m-header__tabs-middle .m-header__tab-link--mobile')?.focus();
      }, 0);
    }
  };
  handleSearch = query => {
    if(!query){
      this.setState({suggestionsPending: false});
      return;
    }
    mHeaderActions.headerSearch(query).then(results => {
      this.setState(prevState => {
        // Ignore stale responses if the user kept typing.
        if((this._searchKeyword || prevState.keyword) !== query){
          return null;
        }

        return {
          keyword: query,
          suggestionsPending: false,
          suggestedProjects: {
            ...prevState.suggestedProjects,
            navigationLinks: results.projects.slice(0, 4).map(project => {
              return {
                id: project.id,
                key: project.id,
                title: `${project.title || ''}`,
                url: `/projects/${project.slug}`,
              };
            }),
            highlight: query,
          },
          suggestedPages: {
            ...prevState.suggestedPages,
            navigationLinks: results.navigations.slice(0, 4).map(navigation => {
              return {
                id: navigation.id,
                key: navigation.id,
                title: `${navigation.title || ''}`,
                url: navigation.url,
              };
            }),
            highlight: query,
          },
        };
      });
    }).catch(() => {
      this.setState(prevState => {
        if((this._searchKeyword || prevState.keyword) !== query){
          return null;
        }
        return {suggestionsPending: false};
      });
    });
  };
  isMobileNavViewport(){
    const width = this.state.width || (typeof window !== 'undefined' ? window.innerWidth : MOBILE_NAV_MAX_WIDTH + 1);
    return width <= MOBILE_NAV_MAX_WIDTH;
  }
  mobileFlyoutProps(){
    const mobileNav = this.isMobileNavViewport();
    const mobileHamburgerActive = mobileNav &&
      Boolean(this.props.mHeader?.isOpen) &&
      !this.isMobileSearchTrap();
    return {
      mobileFlyoutOnActivateOnly: mobileNav,
      mobileSubmenuOpen: mobileHamburgerActive && this.isMobileSubmenuOpen(),
      onTriggerToggle: this.onTabTriggerToggle,
      onTriggerDismiss: this.onTabTriggerDismiss,
    };
  }

  updateDimensions(){
    const globalNav = document.querySelector('[id^="global_navbar"]');
    if (globalNav) {
      document.documentElement.style.setProperty(
        '--ls-global-nav-height',
        `${globalNav.getBoundingClientRect().height}px`,
      );
    }
    this.setState({
      height: window.innerHeight,
      width: window.innerWidth,
    });
  }


  renderBetaFormLink(){
    return (
      <SuperLink to='https://forms.gle/TUXPnQk38DqVHcd4A' className="tg-button tg-button--pill tg-button--beta-link">
        <img className="tg-button__icon" src={iconShareYourFeedback} alt='Share your Feedback icon'/>
        <span className="tg-button__label d-none d-sm-inline-block">
          <span className="d-none d-xl-inline-block">Share your</span> Feedback
        </span>
      </SuperLink>
    );
  }
  renderExpandedTabBar(){
    const leftVal = this.props.mHeader.expandedTabBarOffset + this.props.mHeader.expandedTabBarWidth * .5;
    const widthVal = this.props.mHeader.expandedTabBarWidth;
    let expandedTabBarStyle = {
      left: leftVal || null,
      width: widthVal || null,
    };
    let visibleClass = this.props.mHeader.expandedTabBarVisible ? 'm-header__expanded-tab-bar--is-visible' : '';

    return (
      <div className={`m-header__expanded-tab-bar ${visibleClass}`} style={expandedTabBarStyle}></div>
    );
  }
  renderGetInvolved(){
    if(!this.props.getInvolved) return null;

    const navExpanded = this.tabNavExpanded('get-involved');
    let selectedClass = navExpanded ? 'm-header__tab--is-open' : '';

    return (
      <MHeaderTab ariaExpanded={navExpanded}
                  bgPath={this.bgPath()}
                  {...this.mobileFlyoutProps()}
                  className={`m-header__tab m-header__tab-listed m-header__tab--get-involved ${selectedClass} coupling--full-centered`}
                  id='get-involved'
                  onMouseEnter={(e) => {
                    this.tab_onMouseEnter('get-involved', e);
                  }}
                  onMouseLeave={this.tab_onMouseLeave}
                  title={this.props.getInvolved.title}
                  url={this.props.getInvolved.url}>
        <div className="container container--coupling m-header__tab-menu-container">
          <div className="row">
            <div className="col-12 col-lg-4 transition transition-1">
              <MListNav className="m-header__m-listnav" cmsName={apiValues.NAV_TAKE_ACTION} useListMarkup={true}/>
            </div>
            <div className="col-12 col-lg-4 transition transition-2">
              <MListNav className="m-header__m-listnav" cmsName={apiValues.NAV_WE_WANT_TO_HEAR} useListMarkup={true}/>
            </div>
          </div>
        </div>
      </MHeaderTab>
    );
  }
  renderLogo(){
    const logo = this.props.mHeader.imageLogo || this.props.mHeader.ImageLogo;
    const logoUrl = logo && (logo.url || logo.Url);
    if(!logoUrl) return null;

    return (
      <SuperLink to="/" className="m-header__logo">
        <img alt="LADOT Streets Logo" className="m-header__logo-img"
             src={apiValues.imgPath(logoUrl)}/>
      </SuperLink>
    );
  }
  renderMapsData(){
    if(!this.props.mapsAndData) return null;

    const navExpanded = this.tabNavExpanded('maps-and-data');
    let selectedClass = navExpanded ? 'm-header__tab--is-open' : '';

    return (
      <MHeaderTab ariaExpanded={navExpanded}
                  bgPath={this.bgPath()}
                  {...this.mobileFlyoutProps()}
                  className={`m-header__tab m-header__tab-listed m-header__tab--maps-and-data ${selectedClass} coupling--full-centered`}
                  id='maps-and-data'
                  onMouseEnter={(e) => {
                    this.tab_onMouseEnter('maps-and-data', e);
                  }}
                  onMouseLeave={this.tab_onMouseLeave}
                  title={this.props.mapsAndData.title}
                  url={this.props.mapsAndData.url}>
        <div className="container container--coupling m-header__tab-menu-container">
          <div className="row">
            <div className="col-lg-4 d-none d-lg-block"></div>
            <div className="col-12 col-lg-4 transition transition-1">
              <MListNav className="m-header__m-listnav" cmsName={apiValues.NAV_OUR_PROJECTS_AND_DATA} useListMarkup={true}/>
            </div>
          </div>
        </div>
      </MHeaderTab>
    );
  }
  renderMenuToggle(){
    if(!this.props.whoWeAre) return null;

    const menuOpen = Boolean(this.props.mHeader.isOpen);
    const menuToggleLabel = menuOpen ? 'Close menu' : 'Open menu';
    return (
      <button type="button"
              className="m-header__menu-toggle"
              aria-expanded={menuOpen}
              aria-label={menuToggleLabel}
              onClick={() => this.toggleMenu()}>
        <span className="visually-hidden">{menuToggleLabel}</span>
      </button>
    );
  }
  renderOurProjects(){
    if(!this.props.ourProjects) return null;

    const navExpanded = this.tabNavExpanded('our-projects');
    let selectedClass = navExpanded ? 'm-header__tab--is-open' : '';

    return (
      <MHeaderTab ariaExpanded={navExpanded}
                  bgPath={this.bgPath()}
                  {...this.mobileFlyoutProps()}
                  className={`m-header__tab m-header__tab-listed m-header__tab--our-projects ${selectedClass} coupling--full-centered`}
                  id='our-projects'
                  onMouseEnter={(e) => {
                    this.tab_onMouseEnter('our-projects', e);
                  }}
                  onMouseLeave={this.tab_onMouseLeave}
                  title={this.props.ourProjects.title}
                  url={this.props.ourProjects.url}>
        <div className="container container--coupling m-header__tab-menu-container">
          <div className="row">
            <div className="col-12 col-lg-4 transition transition-1">
              <MListNav className="m-header__m-listnav m-header__project-types" cmsName={apiValues.NAV_FEATURED_PROJECTS} useListMarkup={true}/>
            </div>
            <div className="col-12 col-lg-4 transition transition-2">
              <MListNav className="m-header__project-types m-listnav--blue-outline-pills"
                        cmsName={apiValues.NAV_PROJECT_TYPES}
                        useListMarkup={true}/>
            </div>
          </div>
        </div>
      </MHeaderTab>
    );
  }
  renderLanguage(){
    return (
      <div className="m-header__language"
           onClick={(e) => e.stopPropagation()}
           onMouseEnter={(e) => {
             if(this.isMobileNavViewport()){
               return;
             }
             const btn = e.currentTarget.querySelector('.gt_selected__btn') || e.currentTarget;
             this.showExpandedTabBar('language', btn);
           }}
           onMouseLeave={this.headerUtility_onMouseLeave}>
        <GoogleTranslate variant="header"/>
      </div>
    );
  }
  renderSearchSuggestionLists(){
    const pageLinks = this.state.suggestedPages?.navigationLinks || [];
    const projectLinks = this.state.suggestedProjects?.navigationLinks || [];
    const hasPages = pageLinks.length > 0;
    const hasProjects = projectLinks.length > 0;

    if(!hasPages && !hasProjects){
      if(!this.state.keyword || this.state.suggestionsPending){
        return null;
      }
      return (
        <div className="row">
          <div className="col-12">
            <div className="no-search-results">No results found.</div>
          </div>
        </div>
      );
    }

    return (
      <div className="row">
        {hasPages ? (
          <div className="col-12">
            <MListNav mListNav={this.state.suggestedPages}/>
          </div>
        ) : null}
        {hasProjects ? (
          <div className="col-12">
            <MListNav mListNav={this.state.suggestedProjects}/>
          </div>
        ) : null}
      </div>
    );
  }
  renderSearch(){
    if(!this.props.search) return null;

    let searchingClass = this.state.keyword ? 'is-searching' : '';
    let isExpanded = this.props.mHeader.expandedTab == 'search';

    return (
      <MHeaderTab ariaExpanded={isExpanded}
                  bgPath={this.bgPath()}
                  {...this.mobileFlyoutProps()}
                  className={`m-header__tab--search m-header__tab coupling--full-centered ${searchingClass}`}
                  id='search'
                  onMouseEnter={(e) => {
                    this.tab_onMouseEnter('search', e);
                  }}
                  onMouseLeave={this.tab_onMouseLeave}
                  onTabClick={this.onSearchTabClick}
                  searchTrigger={true}
                  title={this.props.search.title}>
        <div className="m-header__search-content">
          <label id="header-search-label" htmlFor="search-main" className="m-header__search-title">Search projects</label>
          <ButtonInput className="m-header__search-input"
                       ariaLabelledBy="header-search-label"
                       inputID="search-main"
                       onClearClick={this.onSearchClearClick}
                       onInputChange={this.onSearchInputChange}
                       onSubmit={this.search_onSubmit}
                       isLoading={this.state.suggestionsPending}
                       showX={true}/>

          <div className="m-header__search-preview">
            <MListNav className="m-listnav--hide-buttons transition transition-1"
                      cmsName={apiValues.NAV_PROJECT_TYPES}/>
            <div className="row">
              <div className="col-12 col-lg-6 transition transition-2">
                <MListNav cmsName={apiValues.NAV_FEATURED_PROJECTS}/>
                <div className="navigationlink m-listnav__navigationlink navigationlink--blue-outline">
                  <SuperLink to="/projects" className="navigationlink__link">
                    <div className="navigationlink__title">View All Projects</div>
                  </SuperLink>
                </div>
              </div>
              <div className="col-12 col-lg-6 transition transition-3">
                <MListNav cmsName={apiValues.NAV_RECOMMENDED_LINKS}/>
              </div>
            </div>
          </div>
          <div className="m-header__search-results" aria-busy={this.state.suggestionsPending ? 'true' : 'false'}>
            {this.renderSearchSuggestionLists()}
            <SuperLink to={this.state.keyword ? `/search?q=${encodeURIComponent(this._searchKeyword || this.state.keyword)}` : `/search`}
                       className="tg-button tg-button--pill tg-button--black m-header__view-all-results"
                       onClick={this.onViewAllSearchResults}>
              <span className="tg-button__label">View All Search Results</span>
            </SuperLink>
          </div>
        </div>
      </MHeaderTab>
    );
  }
  renderWhatWeDo(){
    if(!this.props.whatWeDo) return null;
    const navExpanded = this.tabNavExpanded('what-we-do');
    let selectedClass = navExpanded ? 'm-header__tab--is-open' : '';
    return (
      <MHeaderTab ariaExpanded={navExpanded}
                  bgPath={this.bgPath()}
                  {...this.mobileFlyoutProps()}
                  className={`m-header__tab m-header__tab-listed m-header__tab--what-we-do ${selectedClass} coupling--full-centered`}
                  id='what-we-do'
                  onMouseEnter={(e) => {
                    this.tab_onMouseEnter('what-we-do', e);
                  }}
                  onMouseLeave={this.tab_onMouseLeave}
                  title={this.props.whatWeDo.title}
                  url={this.props.whatWeDo.url}>
        <div className="container container--coupling m-header__tab-menu-container">
          <div className="row">
            <div className="col-12 col-lg-4 transition transition-1">
              <MListNav className="m-header__m-listnav" cmsName={apiValues.NAV_SAFETY_PROGRAMS} useListMarkup={true}/>
            </div>
            <div className="col-12 col-lg-4 transition transition-2">
              <MListNav className="m-header__m-listnav" cmsName={apiValues.NAV_PUBLIC_SPACE_PROGRAMS} useListMarkup={true}/>
            </div>
          </div>
        </div>
      </MHeaderTab>
    );
  }
  renderWhoWeAre(){
    if(!this.props.whoWeAre) return null;
    const navExpanded = this.tabNavExpanded('who-we-are');
    let selectedClass = navExpanded ? 'm-header__tab--is-open' : '';

    return (
      <MHeaderTab ariaExpanded={navExpanded}
                  bgPath={this.bgPath()}
                  {...this.mobileFlyoutProps()}
                  className={`m-header__tab m-header__tab-listed m-header__tab--who-we-are ${selectedClass} coupling--full-centered`}
                  id='who-we-are'
                  onMouseEnter={(e) => {
                    this.tab_onMouseEnter('who-we-are', e);
                  }}
                  onMouseLeave={this.tab_onMouseLeave}
                  title={this.props.whoWeAre.title}
                  url={this.props.whoWeAre.url}>
        <div className="container container--coupling m-header__tab-menu-container">
          <div className="row">
            <div className="col-lg-4 d-none d-lg-block transition transition-1">
              {this.props.whoWeAre.description ? (
                <div className="m-header__vision-statement">{this.props.whoWeAre.description}</div>
              ) : null}
            </div>
            <div className="col-12 col-lg-4 transition transition-2">
              <MListNav className="m-header__m-listnav" cmsName={apiValues.NAV_LIST_HEADER_WHO_WE_ARE} useListMarkup={true}/>
            </div>
          </div>
        </div>
      </MHeaderTab>
    );
  }
  render(){
    // console.log(`MHeader.render()`, this.props);
    if(!this.props.mHeader) return null;

    const headerTabsActive = Boolean(
      this.props.mHeader.expandedTab ||
      this.props.mHeader.expandedTabBarVisible,
    );
    const mobileNav = this.isMobileNavViewport();
    const hamburgerOpen = Boolean(this.props.mHeader.isOpen);
    const mobileMenuInert = mobileNav && !hamburgerOpen;
    const mobileSearchTrap = this.isMobileSearchTrap();
    const mobileHamburgerActive = mobileNav && hamburgerOpen && !mobileSearchTrap;

    const tabsChrome = (
      <div className="m-header__tabs-chrome"
           {...(mobileSearchTrap ? {inert: ''} : {})}>
        {this.renderMenuToggle()}
        <div className="m-header__tabs-chrome-skip"
             {...(mobileHamburgerActive ? {inert: ''} : {})}>
          {this.renderLogo()}
          {/*{this.renderBetaFormLink()}*/}
        </div>
      </div>
    );
    const tabsNav = (
      <nav className="m-header__tabs-middle"
           aria-label="Primary"
           {...(mobileMenuInert || mobileSearchTrap ? {inert: ''} : {})}>
        {this.renderWhoWeAre()}
        {this.renderWhatWeDo()}
        {this.renderOurProjects()}
        {this.renderGetInvolved()}
        {this.renderMapsData()}
      </nav>
    );
    const tabsLanguage = (
      <div className="m-header__tabs-language-slot"
           {...(mobileSearchTrap || mobileHamburgerActive ? {inert: ''} : {})}>
        {this.renderLanguage()}
      </div>
    );
    const tabsSearch = (
      <div className="m-header__tabs-search-slot"
           {...(mobileHamburgerActive ? {inert: ''} : {})}>
        {this.renderSearch()}
      </div>
    );

    return (
      <header className={`m-header ${this.props.className || ''} ${headerTabsActive ? 'm-header--tabs-active' : ''} ${mobileSearchTrap ? 'm-header--mobile-search-open' : ''} ${mobileHamburgerActive ? 'm-header--mobile-menu-open' : ''}`}>
        <div className="m-header__tab-bar">
          <div className="container container--coupling">
            <div className="row">
              <div className="m-header__tabs">
                {this.renderExpandedTabBar()}
                {mobileNav ? (
                  <>
                    {tabsChrome}
                    {tabsLanguage}
                    {tabsSearch}
                    {tabsNav}
                  </>
                ) : (
                  <>
                    {tabsChrome}
                    {tabsNav}
                    {tabsLanguage}
                    {tabsSearch}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}


export default withRouter(connect(
  (state) => ({
    mHeader: state.mHeader,
    mHeaderTab: state.mHeaderTab,
    whoWeAre: helpers.getByCmsName(state.mListNav, apiValues.NAV_ABOUT),
    whatWeDo: helpers.getByCmsName(state.mListNav, apiValues.NAV_OUR_PROGRAMS),
    ourProjects: helpers.getByCmsName(state.mListNav, apiValues.NAV_OUR_PROJECTS),
    getInvolved: helpers.getByCmsName(state.mListNav, apiValues.NAV_GET_INVOLVED),
    mapsAndData: helpers.getByCmsName(state.mListNav, apiValues.NAV_MAPS_AND_DATA),
    search: helpers.getByCmsName(state.mListNav, apiValues.NAV_SEARCH),
  }),
  (dispatch) => ({
    actions: bindActionCreators(mHeaderActions, dispatch),
  }),
)(MHeader));


MHeader.propTypes = {
  actions: PropTypes.object.isRequired,
  className: PropTypes.string,
  cmsId: PropTypes.string,
  getInvolved: PropTypes.object,
  history: PropTypes.object,
  mapsAndData: PropTypes.object,
  mHeader: PropTypes.object,
  mHeaderTab: PropTypes.array,
  ourProjects: PropTypes.object,
  search: PropTypes.object,
  whatWeDo: PropTypes.object,
  whoWeAre: PropTypes.object,
};
